'use strict';

const PENDING_SSO_KEY = 'audirie.pendingSso';

const parsePendingSso = (raw) => {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
};

exports.PENDING_SSO_KEY = PENDING_SSO_KEY;

exports.peekPendingSso = () => {
  try {
    return parsePendingSso(window.sessionStorage.getItem(PENDING_SSO_KEY));
  } catch (err) {
    return null;
  }
};

exports.readPendingSso = () => {
  try {
    const pending = parsePendingSso(window.sessionStorage.getItem(PENDING_SSO_KEY));
    window.sessionStorage.removeItem(PENDING_SSO_KEY);
    return pending;
  } catch (err) {
    return null;
  }
};

exports.storePendingSso = (provider) => {
  try {
    window.sessionStorage.setItem(PENDING_SSO_KEY, JSON.stringify(provider));
  } catch (err) { /* best effort */ }
};

exports.clearPendingSso = () => {
  try {
    window.sessionStorage.removeItem(PENDING_SSO_KEY);
  } catch (err) { /* best effort */ }
};

exports.extractLoginErrorMessage = (err, fallback = 'Login Failed') => {
  const data = err?.response?.data;
  if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
  if (typeof data === 'string' && data.trim()) return data;
  if (err?.response?.status === 401) return 'Invalid password';
  return fallback;
};

exports.normaliseEmail = (email) => {
  if (typeof email !== 'string') return '';
  return email.trim().toLowerCase();
};

/**
 * True when both emails are present and differ. Missing either side means we
 * cannot compare (e.g. enrollment with no typed email, or IdP omitted email),
 * so we do not reject.
 */
exports.shouldRejectSsoEmailMismatch = (intendedEmail, assertedEmail) => {
  const intended = exports.normaliseEmail(intendedEmail);
  const asserted = exports.normaliseEmail(assertedEmail);
  if (!intended || !asserted) return false;
  return intended !== asserted;
};
